<template>
  <b-alert show variant="success" v-if="viewData.success">
    <h4 class="alert-heading">Email enviado!</h4>
    <p>As instruções para redefinir sua senha foram enviadas para seu email.</p>
    <hr />
  </b-alert>

  <b-form class="form-signin" v-else>
    <img class="mb-4" src="/images/logo_veins.png" alt style="width: 19em"/>
    <h1 class="h3 mb-3 font-weight-normal">Informe seu email</h1>

    <error-container v-bind:errors="viewData.errors || []" />

    <b-form-group>
      <label for="inputEmail" class="sr-only">Email</label>
      <b-input
        v-on:keyup.enter="save"
        :state="isOk('email')"
        v-model="state.email"
        placeholder="Email"
        autofocus
        required
      />
      <b-form-invalid-feedback style="text-align:left">{{getError('email')}}</b-form-invalid-feedback>
    </b-form-group>

    <button
      type="button"
      v-bind:disabled="viewData.loading"
      class="btn btn-primary btn-lg btn-block"
      v-on:click="save"
    >
      <b-icon v-if="viewData.loading" icon="three-dots" animation="cylon"></b-icon>
      <span v-else>Enviar</span>
    </button>
  </b-form>
</template>


<script>
import { Auth } from '../vue/auth';
import { Api } from '../vue/api';
import helpers from '../vue/helpers';

const API = new Api();

export default {
  name: 'login',
  data: function() {
    return {
      state: {
        email: '',
      },
      viewData: {
        loading: false,
        errors: [],
        success: false,
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    const hasSession = await Auth.hasSession();
    if (hasSession) {
      this.$router.push('/');
    }
  },
  methods: {
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    async save() {
      try {
        this.viewData.loading = true;
        const result = await API.post('/run', {
          path: '/forgot',
          method: 'post',
          data: this.state,
        });
        this.viewData.success = true;
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }

      this.viewData.loading = false;
    },
  },
  components: {},
};
</script>